import { PERSONAS, useDemo } from '../demo/DemoContext.jsx';
import { DEMO_PROFILES } from '../demo/store.js';

/* The demo bar. Deliberately loud.
 *
 * It carries the two switches a walkthrough needs and a real deployment must
 * never have:
 *
 *   • Viewing as — stands in for the Hub room gate that has not been issued
 *     yet. Becomes `hasRoom(...)` and disappears in Phase 2b.
 *   • Profile — stands in for the Entra + HR data the "who raised it" rules
 *     read. It is here so the leadership rule can be shown firing.
 *
 * When this bar goes, the prototype is over. That is the intended signal.
 */
export default function DemoBar() {
  const { persona, setPersona, profileId, setProfileId, reset } = useDemo();

  async function onReset() {
    // Everything is local to this browser, so there is nothing to lose but the
    // demo — but people do get attached to a ticket they just raised.
    if (!window.confirm('Throw away every ticket raised in this demo and start from the seed data?')) return;
    await reset();
  }

  return (
    <div className="demobar">
      <span className="demobar__tag">
        <span className="material-symbols-outlined" style={{ fontSize: 14 }} aria-hidden="true">
          science
        </span>
        Prototype
      </span>
      <span>Demo tickets live only in this browser. Every form files here, and nothing is sent to IT.</span>

      <span className="demobar__spacer" />

      <label className="inline" style={{ gap: 6 }}>
        <span>Profile</span>
        <select
          className="demobar__segbtn"
          value={profileId}
          onChange={(e) => setProfileId(e.target.value)}
          style={{ border: '1px solid rgba(138,90,22,.3)', borderRadius: 8 }}
        >
          {Object.values(DEMO_PROFILES).map((p) => (
            <option key={p.id} value={p.id}>
              {p.label}
            </option>
          ))}
        </select>
      </label>

      <div className="demobar__seg" role="group" aria-label="Viewing as">
        {PERSONAS.map((p) => (
          <button
            key={p.id}
            type="button"
            className={`demobar__segbtn${persona === p.id ? ' demobar__segbtn--on' : ''}`}
            aria-pressed={persona === p.id}
            onClick={() => setPersona(p.id)}
          >
            {p.label}
          </button>
        ))}
      </div>

      <button type="button" className="demobar__reset" onClick={onReset}>
        Reset
      </button>
    </div>
  );
}
